import React from 'react';

type Props = {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalRows: number;
  onPrevious: () => void;
  onNext: () => void;
};

export default function InvoicePagination({
  currentPage,
  totalPages,
  pageSize,
  totalRows,
  onPrevious,
  onNext,
}: Props) {
  if (totalRows <= 0) {
    return null;
  }

  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalRows);

  return (
    <div className="flex items-center justify-between border-t border-outline/40 px-4 py-3">
      <p className="text-xs text-on-surface-variant">
        Showing invoices {start}-{end} of {totalRows}
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          className="btn-secondary px-3 py-1 text-xs"
          disabled={currentPage === 1}
          onClick={onPrevious}
        >
          Previous
        </button>
        <button
          type="button"
          className="btn-secondary px-3 py-1 text-xs"
          disabled={currentPage === totalPages}
          onClick={onNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}
